// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bg-lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/page-bg-shadow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__w9f\\+l {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex !important;
  flex-direction: column;
  background-color: #100f0f;
  position: relative;
}
.styles_wrapper__w9f\\+l::before, .styles_wrapper__w9f\\+l::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 0;
  width: 100%;
}
.styles_wrapper__w9f\\+l > div {
  z-index: 1;
}
.styles_wrapper__w9f\\+l:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: left bottom;
  background-repeat: repeat no-repeat;
}
.styles_wrapper__w9f\\+l:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat no-repeat;
}

.styles_contentWrapper__XUDde {
  padding: 32px;
  display: flex;
  flex-grow: 1;
  gap: 40px;
}
@media (max-width: 992px) {
  .styles_contentWrapper__XUDde {
    padding: 24px 15px;
  }
}

.styles_mainContent__OJhcX {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_pageContent__Su7mt {
  height: 100%;
  overflow: auto;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/components/pageWrapper/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBCWS;EDVT,kBAAA;AAFF;AAIE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAHJ;AAME;EACE,UAAA;AAJJ;AAOE;EACE,yDAAA;EACA,gCAAA;EACA,mCAAA;AALJ;AAQE;EACE,yDAAA;EACA,6BAAA;EACA,sBAAA;EACA,sCAAA;AANJ;;AAUA;EACE,aAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;AAPF;AEZE;EFeF;IAOI,kBAAA;EANF;AACF;;AASA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANF;;AASA;EACE,YAAA;EACA,cAAA;EACA,aAAA;AANF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  display: flex !important;\n  flex-direction: column;\n  background-color: $black-bg;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n    width: 100%;\n  }\n\n  & > div {\n    z-index: 1;\n  }\n\n  &:before {\n    background-image: url('../../assets/images/bg-lines.png');\n    background-position: left bottom;\n    background-repeat: repeat no-repeat;\n  }\n\n  &:after {\n    background-image: url('../../assets/images/page-bg-shadow.png');\n    background-position: left top;\n    background-size: cover;\n    background-repeat: no-repeat no-repeat;\n  }\n}\n\n.contentWrapper {\n  padding: 32px;\n  display: flex;\n  flex-grow: 1;\n  gap: 40px;\n\n  @include lg {\n    padding: 24px 15px;\n  }\n}\n\n.mainContent {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.pageContent {\n  height: 100%;\n  overflow: auto;\n  display: flex;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__w9f+l`,
	"contentWrapper": `styles_contentWrapper__XUDde`,
	"mainContent": `styles_mainContent__OJhcX`,
	"pageContent": `styles_pageContent__Su7mt`
};
export default ___CSS_LOADER_EXPORT___;
